









import CBadge from '~/components/shared/configurable/badge/CBadge.vue'
import { defineComponent } from '~/utils/nuxt3-migration'
import { ciRefresh } from '~/icons/source/regular/refresh'
import { defineComponentTranslations } from '~/utils/i18n'

export default defineComponent({
  components: { CBadge },
  setup() {
    return { ciRefresh }
  },
  i18n: defineComponentTranslations({
    touched: {
      en: 'Touched',
      el: 'Ανανεωμένη'
    }
  })
})
